import React from "react";
import { Box, Typography, TextField, IconButton } from "@mui/material";
import { Trash2, ArrowUp, ArrowDown } from "lucide-react";
import { GeocodingSearch } from "./GeocodingSearch";
import { useScrollytellTranslation } from "../Admin/scrollytellContext";

export const WaypointsListControls = ({
  waypoints = [],
  onUpdateTitle,
  onRemove,
  onAdd,
  onReorder,
}) => {
  const t = useScrollytellTranslation();

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Typography
          variant="caption"
          sx={{ color: "#64748B", fontWeight: 700, textTransform: "uppercase" }}
        >
          {t("mapConfigSubMenu.waypointsTitle", "Stoppesteder")} ({waypoints.length})
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            maxHeight: 180,
            overflowY: "auto",
            flexShrink: 0,
          }}
        >
          {waypoints.map((wp, index) => (
            <Box
              key={wp.id || `wp-${index}`}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                backgroundColor: "#F8FAFC",
                p: 0.75,
                borderRadius: "4px",
                border: "1px solid #E2E8F0",
              }}
            >
              <TextField
                size="small"
                fullWidth
                value={wp.title || ""}
                onChange={(e) => onUpdateTitle(index, e.target.value)}
                inputProps={{
                  "aria-label": `${t("mapConfigSubMenu.waypointTitleAria", "Tittel for stoppested")} ${index + 1}`,
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    fontSize: "12px",
                    color: "#1E293B",
                    backgroundColor: "#FFFFFF",
                  },
                }}
              />
              <IconButton
                size="small"
                disabled={index === 0}
                aria-label={t(
                  "mapConfigSubMenu.moveWaypointUpAria",
                  `Flytt stopp ${index + 1} opp`,
                  { index: index + 1 }
                )}
                onClick={() => onReorder && onReorder(index, index - 1)}
                sx={{ color: "#64748B", "&:hover": { backgroundColor: "rgba(100,116,139,0.1)" } }}
              >
                <ArrowUp size={16} />
              </IconButton>
              <IconButton
                size="small"
                disabled={index === waypoints.length - 1}
                aria-label={t(
                  "mapConfigSubMenu.moveWaypointDownAria",
                  `Flytt stopp ${index + 1} ned`,
                  { index: index + 1 }
                )}
                onClick={() => onReorder && onReorder(index, index + 1)}
                sx={{ color: "#64748B", "&:hover": { backgroundColor: "rgba(100,116,139,0.1)" } }}
              >
                <ArrowDown size={16} />
              </IconButton>
              <IconButton
                size="small"
                aria-label={t("mapConfigSubMenu.deleteWaypoint", "Slett stoppested")}
                onClick={() => onRemove(index)}
                sx={{ color: "#EF4444", "&:hover": { backgroundColor: "rgba(239,68,68,0.1)" } }}
              >
                <Trash2 size={16} />
              </IconButton>
            </Box>
          ))}
        </Box>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Typography
          variant="caption"
          sx={{ color: "#64748B", fontWeight: 700, textTransform: "uppercase" }}
        >
          {t("mapConfigSubMenu.addWaypoint", "Legg til stoppested")}
        </Typography>
        <GeocodingSearch onSelectPlace={onAdd} />
      </Box>
    </>
  );
};
